import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import {
  selectMessageContent,
  setMessageContentProperty,
} from '../../containers/CreateMessage/createMessageSlice';
import {
  clearChatDraft,
  selectDraft,
  setChatDraft,
} from '../../containers/ChatDrafts/chatDraftsSlice';

export function useChatDraft(
  chatId: string | undefined,
  replyId: number | undefined,
  editId: number | undefined
): {
  clearChatDraft: () => void;
  draftReplyId: number | undefined;
  draftEditId: number | undefined;
  draftText: string | undefined;
} {
  const dispatch = useAppDispatch();
  const { text } = useAppSelector(selectMessageContent);
  const draft = useAppSelector(chatId ? selectDraft(chatId) : () => null);

  const textRef = useRef(text);
  const replyIdRef = useRef<number | undefined>(replyId);
  const editIdRef = useRef<number | undefined>(editId);
  textRef.current = text;
  replyIdRef.current = replyId;
  editIdRef.current = editId;

  useEffect(() => {
    if (!chatId) return;

    if (draft?.text) {
      dispatch(setMessageContentProperty({ key: 'text', value: draft.text }));
    }

    return () => {
      dispatch(
        setChatDraft({
          chatId,
          draft: {
            text: textRef.current,
            replyId: replyIdRef.current,
            editId: editIdRef.current,
          },
        })
      );
    };
    // chatId is the only dep — re-run only when the chat changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatId]);

  return {
    clearChatDraft: () => {
      if (chatId) {
        textRef.current = '';
        replyIdRef.current = undefined;
        editIdRef.current = undefined;
        dispatch(clearChatDraft(chatId));
      }
    },
    draftReplyId: draft?.replyId,
    draftEditId: draft?.editId,
    draftText: draft?.text,
  };
}
